import React from 'react';
import { Form, Input, Button,Spin,DatePicker, message,Card,Result } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const dateFormat = 'DD/MM/YYYY';
const { RangePicker } = DatePicker;
const { TextArea } = Input;



var token= ''
var sacco= ''
var username=''


class LoanInterestWaiverForm extends React.Component {

  state = {
    idtypeName:'' ,  
    idtypeDescription:'',
    datarequested:false,
    waiver_date:'',
    datasubmittedsuccessfully:false,
    message:'',
    waive_amount:0,
    waive_reason:''
 
  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)

      }else{
       sacco= ''
       username=''


    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    //set the waive amount
    this.setState({waive_amount:this.props.selected_scheduleobject.interest})
  }



  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{

      if(this.state.datasubmittedsuccessfully===true){
        return (

        <Card>
        <Result
        status="success"
        title="Successfully updated"
        subTitle={this.state.message}
        extra={[
          <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
        ]}
        />
        </Card>
        )

      }else{

        return (
          <div>
  
           <Form >
       
            <FormItem label={"Select date"}>
              <DatePicker onChange={(date, dateString)=>{this.setState({ waiver_date: dateString})}} format={dateFormat} />
            </FormItem>

            <FormItem label="Amount">
            <Input  type='number'  placeholder="Amount" value={this.state.waive_amount} onChange={(val)=>{this.setState({waive_amount:val.target.value})}} />
            </FormItem>

            <FormItem label="Reason/details">
           
            <TextArea
                placeholder="Transaction Details"
                autoSize={{ minRows: 2, maxRows: 8 }}
                value={this.state.waive_reason}
                onChange={(val)=>{this.setState({waive_reason:val.target.value})}}
              />
           
           
            </FormItem>


            <Button type='primary' key="back" onClick={()=>{
              if (this.state.waiver_date===""){
                message.error("Please select date")
              }else if(Number(this.state.waive_amount)>Number(this.props.selected_scheduleobject.interest)){
                message.error("Amount cant be greater than shedule interest")
              }else if (this.state.waive_amount<0)
                message.error("Amount cant be less or equal to zero")
              else{
  
              //make qery now
              let form_data = new FormData();
              form_data.append('current_selected_schedule',this.props.selected_scheduleobject.id);
              form_data.append('waiver_date', this.state.waiver_date);
              form_data.append('waive_amount', this.state.waive_amount);
              form_data.append('waive_reason', this.state.waive_reason);
              form_data.append('user',username );

              form_data.append('sacco',sacco);
  
              this.setState({datarequested:true})
  
              axios.post(serverconfig.backendserverurl+'/customqueries/confirmloan_interestwaiving', form_data,{
                headers: {
                  'content-type': 'multipart/form-data'
                } })
              .then(res => {
                this.setState({datarequested:false})
                this.setState({message:res.data.message})
                this.setState({datasubmittedsuccessfully:true})
  
  
              })
              .catch(error => console.log(error))
              }
  
            }}>
            Waive interest 
            </Button>
  
       </Form>
          </div>
        );
  
      }

    }

  }

}


export default LoanInterestWaiverForm;



